import { render } from "./CateringFooter.vue?vue&type=template&id=2b5e0e33"
import script from "./CateringFooter.vue?vue&type=script&lang=js"
export * from "./CateringFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__